import { UPDATE_MODE } from "../../actions/QueryBuilder/actionConstants";

const mode = (state = "query", action) => {
	/**
	 * action: {
	 *  type,
	 *  mode
	 * }
	 */
	switch (action.type) {
		case UPDATE_MODE:
			return action.mode;
		default:
			return state;
	}
};

export default mode;
